export const baseUrl = 'https://chef.taplak.id/api/'
// export const baseUrl = 'http://localhost:8000/api/'